import React, { useEffect,useRef,useState } from 'react';
import AppStrings from '../../config/appstring';
import axios from 'axios';
import DiscountType from '../../Class/DiscountTypes';
import FeesPrint from '../Print/FeesPrint';

function AcademicFeesForm1({onClose, studentData, formData, setFormData, handleFormChange  }) {
    const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
 const [activeForm, setActiveForm] = useState(null); 
const [feeDetails, setFeeDetails] = useState([]);
 const closeModal = () => setActiveForm(null);
  const [discountModalIndex, setDiscountModalIndex] = useState(null); // Track which row is editing
  const [tempDiscount, setTempDiscount] = useState('');
    const discountInputRef = useRef(null);
    const [tempDiscountType, setTempDiscountType] = useState('');
const [tempDiscountRemarks, setTempDiscountRemarks] = useState('');
const [showConfirmModal, setShowConfirmModal] = useState(false);
const closeForm = () => setActiveForm(null);
const [printRefNo, setPrintRefNo] = useState(null);

 const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

 const handleOpenDiscountModal = (index) => {
   setTempDiscount(feeDetails[index].discount || '');
  setTempDiscountType(feeDetails[index].discountType || ''); // 👈 set type too
   setTempDiscountRemarks(feeDetails[index].discountRemark || ''); // 👈 set type too
  setDiscountModalIndex(index);
  };

  const handleSaveDiscount = () => {
   if (discountModalIndex !== null) {
      const idx = discountModalIndex;
      const oldFee = feeDetails[idx];
      const oldFeeAmount = parseFloat(oldFee.FEES) || 0;
      const oldDiscount = parseFloat(oldFee.discount) || 0;
      const oldPayable = oldFeeAmount - oldDiscount;
      const oldPaid = parseFloat(oldFee.current) || 0;

      const newDiscount = parseFloat(tempDiscount) || 0;
      const newPayable = oldFeeAmount - newDiscount;

      const updated = [...feeDetails];
      updated[idx].discount = tempDiscount;
      updated[idx].discountType = tempDiscountType;
      updated[idx].discountRemark = tempDiscountRemarks;

      // ✅ Update paid amount if user had paid full earlier
      if (oldPaid === oldPayable) {
        updated[idx].current = newPayable.toFixed(2);
      }

      setFeeDetails(updated);
      setDiscountModalIndex(null);
    }
  };

  const handleCancelDiscount = () => {
    setDiscountModalIndex(null);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);

  const handleSubmit = async () => {
      const payload = {
        student: {
          id: studentData.id,
           admissionDate: admissionDate,
           type: studentData.addfees,
        },
        fees: feeDetails .filter(({ current, discount }) => {
          const paid = parseFloat(current) || 0;
          const off = parseFloat(discount) || 0;
          return paid + off > 0;
        }).map(({ TYPE, FEES,current, discount,discountType,discountRemark }) => ({
          TYPE,
          FEES,
          current,
          discount,
          discountType,
          discountRemark,
        }))
      };
  
      try {
        //console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log(result.data[0].REFNO,"-------->");
        setPrintRefNo(result.data[0].REFNO);
       alert(result.message || "Data saved successfully!");



    //   handleCancel();   
    // onClose();   
    
    
    
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

const handleYesNo = () => {
  setShowConfirmModal(true);
};

    useEffect(() => {
        
        handlePayClick();
      }, []);

      
  useEffect(() => {
    if (discountModalIndex !== null && discountInputRef.current) {
      discountInputRef.current.focus();
    }
  }, [discountModalIndex]);

    const handlePayClick = async () => {
    const feeType = studentData.addfees;
    const className = studentData.class;
    const type = 'N';
    const AdmissionID=studentData.id

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.FeesDetailGet+`?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;
//console.log(result,'llllllllllllllllllll');
      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ 
          ...item, 
          current: '',
           discount: '' ,
           discountType: '', // <-- add this line
  discountRemark: '',
        }));
         //setMode('pay');
       // setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
       // alert(`No fee records found for ${row.NAME}`);
        alert(`No fee records found for HIIIII`);
        setFeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      alert("Failed to fetch fee details.");
    }
  };

  const handleCancel =  async () => {
   // setSelectedRow(null);
   // setFeeDetails([]);
   setFeeDetails([]);
  };


  return (

    

   <div style={modalOverlayStyle}>  
          <div style={modalStyle}>
        <>


        {studentData && (
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <strong>Student:</strong> {studentData.name}
            <strong>Id:</strong> {studentData.id}
          </div>
        )}

            {/* <h3>{selectedRow.STUDENT_ID+'-'+selectedRow.NAME+'-'+selectedRow.CLASS}</h3> */}
            <div style={{ marginTop: '15px', textAlign: 'left', fontWeight: 'bold', fontSize: '16px' }}>
            <div className="row">
        <div className="col-25">
        <div className="col-25">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
            <input
              required
              type="date"
              name="DOADM"
              autoComplete="off"
              className="input"
              value={admissionDate}
              onChange={(e) => setAdmissionDate(e.target.value)}
            />
            
            </div> 
          </div> 
          </div>
          </div>
                </div>
            {feeDetails.length > 0 ? (
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse',   tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                     <th style={{ ...headerCellStyle, width: '20px' }}></th>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount Type</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Paid</th>
                    <th style={headerCellStyle}>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, idx) => {
                    const feeAmount = parseFloat(fee.FEES) || 0;
                    const discount = parseFloat(fee.discount) || 0;
                    const payable = feeAmount - discount;
                    const discountType=fee.discountType;
                    const discountRemark=fee.discountRemark;

                    return (
                      <tr key={idx}>
                        

                          <td style={cellStyle}>
                            <div>
                        <input
                          type="checkbox"
                          checked={parseFloat(fee.current || 0) === payable}
                          onChange={(e) => {
                            const paidAmount = e.target.checked ? payable.toFixed(2) : '';
                            handleInputChange(idx, 'current', paidAmount);
                          }}
                        />
                        </div>
                        <div>
                        <input
                          type="checkbox"
                          checked={parseFloat(fee.current || 0) === payable}
                          onChange={(e) => {
                            const paidAmount = e.target.checked ? payable.toFixed(2) : '';
                            handleInputChange(idx, 'current', paidAmount);
                          }}
                        />
                        </div>
                      </td>
                        <td style={cellStyle}><div>{fee.TYPE}</div><div>{fee.TYPE}</div></td>
                        <td style={cellStyle}><div>{fee.FEES}</div><div>{fee.FEES}</div></td>
                         <td style={cellStyle}><div>{fee.discountType}</div><div>{fee.discountType}</div></td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          

                           <button
    onClick={() => handleOpenDiscountModal(idx)} // function to open modal or edit
    className="input"
    style={{
      width: '100%',
      padding: '8px',
      textAlign: 'left',
      backgroundColor: '#f9f9f9',
      border: '1px solid #ccc',
      borderRadius: '4px',
      cursor: 'pointer',
      color:'Black'
    }}
  >
    <span role="img" aria-label="discount">🏷️</span>
    ₹ {fee.discount ? fee.discount : ''}
  </button>
                          </div>
                        </td>
                        <td style={cellStyle}>
                            <div>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Paid Amount"
                            value={fee.current}
                            onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                            className="input PayInPut"
                          />
                          </div>
                          </div>
                          <div>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Paid Amount"
                            value={fee.current}
                            onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                            className="input PayInPut"
                          />
                          </div>
                          </div>
                          <div style={{ fontSize: '0.8em', color: '#555' }}>
                            Payable: ₹{payable.toFixed(2)}
                          </div>
                        </td>
                       <td style={cellStyle}>
  {(fee.discountRemark || '-').toUpperCase()}
</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            
            ) : (
              <p>No fee data available.</p>
            )}
             <div style={{ marginTop: '15px', textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  Total Paid Amount: ₹{totalPaid.toFixed(2)}
                </div>
                <button onClick={handleYesNo} style={{ marginTop: '15px' }}>Save</button>
            <button onClick={onClose} style={{ marginTop: '15px' }}>Close</button>
 {discountModalIndex !== null && (
          <div style={modalOverlayStyle}>
            <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
                <h3>Discount Type</h3>
             <DiscountType
    //   value={formData.PLACE} // Controlled value for the select dropdown
    //     onChange={handleFormChange} // Handle change to update formData
     value={tempDiscountType}
  onChange={(val) => setTempDiscountType(val)}
      />

              <h3>Enter Discount</h3>
               <div class="coolinput">
                          <input
                          ref={discountInputRef}
                            type="text"
                            placeholder="Discount Amount"
                            className="input PayInPut"
                            value={tempDiscount}
                            onChange={(e) => setTempDiscount(e.target.value)}
                          />
                          </div>
                          <h3>Remarks</h3>
               <div class="coolinput">
                          <input
                    
                            type="text"
                            placeholder="Remarks"
                            className="input PayInPut"
                            value={tempDiscountRemarks}
                            onChange={(e) => setTempDiscountRemarks(e.target.value)}
                          />
                          </div>
                          
            
              <div style={{ marginTop: '15px' }}>
                <button onClick={handleSaveDiscount}>Save</button>
                <button onClick={handleCancelDiscount} style={{ marginLeft: '10px' }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}


{showConfirmModal && (
  <div style={modalOverlayStyle}>
    <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
      <h3>Confirm Save</h3>
      <p>Are you sure you want to save this data?</p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleSubmit(); // ✅ proceed with actual submission
          }}
        >
          Yes
        </button>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ marginLeft: '10px' }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

{printRefNo && (
  <div style={modalOverlayStyle}>
    <div style={modalStyle}>
      <FeesPrint
              RefNo={printRefNo}
              onClose={() => {
                setPrintRefNo(null); // ✅ close the print modal
                onClose();           // ✅ now close the full form
              }}
            />
    </div>
  </div>
)}
            </>
        </div> </div>
  );
}

export default AcademicFeesForm1;

// === Styles ===

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const headerCellStyle = {
  padding: '8px',
  backgroundColor: '#f2f2f2',
  // border: '1px solid #ccc', // ✅ Add thi
};

const cellStyle = {
  padding: '4px',
  fontSize: '13px',
  // border: '1px solid #ccc', // ✅ Add thi
};
